module.exports = __webpack_public_path__ + "img/steam-square.3514d65a.svg";